import React from 'react';
import Header from '../Components/Header';
import './Styles/StaticPage.css';

const AboutUsPage: React.FC = () => {
  return (
    <div className="page-container">
      <Header />
      <main className="static-content">
        <div className="content-wrapper">
          <h1 className="page-title">About Hameruha Learning</h1>
          <p className="page-intro">
            We are dedicated to providing accessible, high-quality educational content to learners everywhere. Our mission is to empower individuals to achieve their personal and professional goals through the power of online video learning.
          </p>

          <div className="feature-section">
            <div className="feature-item">
              <h3>Our Vision</h3>
              <p>To create a global learning community where knowledge is not just consumed, but shared, inspiring a new generation of thinkers, creators, and leaders.</p>
            </div>
            <div className="feature-item">
              <h3>Our Approach</h3>
              <p>We partner with expert instructors to create engaging courses on a wide variety of subjects. Every video is crafted to be clear, concise, and practical.</p>
            </div>
            <div className="feature-item">
              <h3>Our Commitment</h3>
              <p>We are committed to continuous improvement, ensuring our platform is user-friendly, our content is up-to-date, and our community is supportive and inclusive.</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutUsPage;